// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { Backdrop, CircularProgress } from "@mui/material";

interface CircularLoadingPropsInterface {
    openLoading: boolean;
}

const CircularLoading = (props: CircularLoadingPropsInterface) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
            open={props.openLoading}
        >
            <CircularProgress color="primary" />
        </Backdrop>
    );
};

export default CircularLoading;
